import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ConfirmDialog(props) {
  const { cancelText, confirmText, confirmMessage, confirmTitle, confirmOpen, onClose, data } = props;
  const [open, setOpen] = React.useState(confirmOpen);
  const handleNo = () => {
    setOpen(false)
    onClose(false);
  };
  const handleYes = () => {
    setOpen(false);
    onClose(true);
  };
  const handleClose = () => {
  }
  return (
    <div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{confirmTitle}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" style={{ color: 'black' }}>
            {confirmMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleYes} style={{color:'#f00',fontWeight:600}} color="primary">
            {confirmText ? confirmText : 'Yes'}
          </Button>
          <Button onClick={handleNo} style={{fontWeight:600}}>
            {cancelText ? cancelText : 'No'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}